import { Instagram, Facebook, Music2, MessageCircle, Send } from "lucide-react";
import { useLang, loc, CONTACTS } from "../i18n";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  ["#home", "home"],
  ["#what-we-do", "what"],
  ["#services", "services"],
  ["#projects", "projects"],
  ["#about", "about"],
  ["#reviews", "reviews"],
  ["#socials", "socials"],
  ["#contacts", "contacts"],
];

export const Footer = ({ services }) => {
  const { lang, t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#040404]">
      <div className="mx-auto max-w-[1500px] px-5 pb-28 pt-16 md:px-10 md:pb-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src="/logo.png" alt="PROALP22" className="h-32 w-auto" />
            <p className="mt-4 max-w-xs text-sm text-neutral-400">{t.footer.desc}</p>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Instagram, href: "#" },
                { Icon: Facebook, href: CONTACTS.facebook },
                { Icon: Music2, href: "#" },
                { Icon: MessageCircle, href: CONTACTS.whatsapp },
                { Icon: Send, href: "#" },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  data-testid={`footer-social-${i}`}
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel="noreferrer"
                  className="flex h-10 w-10 items-center justify-center border border-white/15 text-neutral-400 transition-colors hover:border-[#FF5A00] hover:text-[#FF5A00]"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-neutral-500">{t.footer.nav}</p>
            <ul className="mt-5 space-y-3">
              {LINKS.map(([id, key]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-nav-${key}`}
                    onClick={() => scrollToId(id)}
                    className="text-sm text-neutral-300 transition-colors hover:text-[#FF5A00]"
                  >
                    {t.nav[key]}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-neutral-500">{t.footer.services}</p>
            <ul className="mt-5 space-y-3">
              {services.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <button
                    data-testid={`footer-service-${s.id}`}
                    onClick={() => scrollToId("#services")}
                    className="text-sm text-neutral-300 transition-colors hover:text-[#FF5A00]"
                  >
                    {loc(s.title, lang)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-neutral-500">{t.footer.contacts}</p>
            <ul className="mt-5 space-y-3 text-sm text-neutral-300">
              <li>
                <a data-testid="footer-phone" href={CONTACTS.phoneHref} className="transition-colors hover:text-[#FF5A00]">
                  {CONTACTS.phone}
                </a>
              </li>
              <li>
                <a data-testid="footer-email" href={`mailto:${CONTACTS.email}`} className="transition-colors hover:text-[#FF5A00]">
                  {CONTACTS.email}
                </a>
              </li>
              <li data-testid="footer-address">{CONTACTS.address}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-neutral-500 md:flex-row md:items-center">
          <p data-testid="footer-copyright">© {year} PROALP22. {t.footer.rights}</p>
          <div className="flex gap-6">
            <a data-testid="footer-privacy" href="/privacidade" className="transition-colors hover:text-[#FF5A00]">{t.footer.privacy}</a>
            <a data-testid="footer-cookie" href="/cookies" className="transition-colors hover:text-[#FF5A00]">{t.footer.cookie}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
